const cabs = [
  {
    id: "cab01",
    name: "Swift Dzire",
    type: "Sedan",
    photo: "https://imgd.aeplcdn.com/664x374/n/cw/ec/130591/fronx-exterior-right-front-three-quarter-109.jpeg?isig=0&q=80",
    seats: 4,
    bags: 2,
    ac: true,
    pricePerKm: 12,
    basePrice: 500,
    description: "Comfortable sedan perfect for city rides and short trips. Well-maintained with experienced drivers.",
    features: ["AC", "Music System", "GPS", "First Aid Kit"],
    rating: 4.5,
    reviews: 128
  },
  {
    id: "cab02",
    name: "Toyota Innova",
    type: "SUV",
    photo: "https://imgd.aeplcdn.com/664x374/n/cw/ec/140809/innova-crysta-exterior-right-front-three-quarter-2.png?isig=0&q=80",
    seats: 7,
    bags: 4,
    ac: true,
    pricePerKm: 18,
    basePrice: 800,
    description: "Spacious SUV ideal for family trips and group travel. Extra legroom and luggage space.",
    features: ["AC", "Music System", "GPS", "First Aid Kit", "Charging Ports", "Extra Legroom"],
    rating: 4.8,
    reviews: 256
  },
  {
    id: "cab03",
    name: "Honda City",
    type: "Premium Sedan",
    photo: "https://imgd.aeplcdn.com/664x374/n/cw/ec/134287/city-exterior-right-front-three-quarter-2.png?isig=0&q=80",
    seats: 4,
    bags: 2,
    ac: true,
    pricePerKm: 15,
    basePrice: 600,
    description: "Premium sedan with superior comfort and style. Perfect for business travel and special occasions.",
    features: ["AC", "Premium Music System", "GPS", "First Aid Kit", "Leather Seats", "WiFi"],
    rating: 4.7,
    reviews: 189
  },
  {
    id: "cab04",
    name: "Mahindra XUV700",
    type: "Premium SUV",
    photo: "https://imgd.aeplcdn.com/664x374/n/cw/ec/42355/xuv700-exterior-right-front-three-quarter.jpeg?isig=0&q=80",
    seats: 7,
    bags: 5,
    ac: true,
    pricePerKm: 22,
    basePrice: 1000,
    description: "Luxury SUV with advanced features and maximum comfort. Best for long distance travel.",
    features: ["AC", "Premium Music System", "GPS", "First Aid Kit", "Leather Seats", "WiFi", "Sunroof", "ADAS"],
    rating: 4.9,
    reviews: 312
  },
  {
    id: "cab05",
    name: "Maruti Ertiga",
    type: "MUV",
    photo: "https://imgd.aeplcdn.com/664x374/n/cw/ec/115777/ertiga-exterior-right-front-three-quarter-2.jpeg?isig=0&q=80",
    seats: 7,
    bags: 3,
    ac: true,
    pricePerKm: 14,
    basePrice: 600,
    description: "Budget-friendly MUV with good space and comfort. Perfect for family trips.",
    features: ["AC", "Music System", "GPS", "First Aid Kit"],
    rating: 4.4,
    reviews: 175
  },
  {
    id: "cab06",
    name: "Hyundai Creta",
    type: "Compact SUV",
    photo: "https://imgd.aeplcdn.com/664x374/n/cw/ec/106815/creta-exterior-right-front-three-quarter-4.png?isig=0&q=80",
    seats: 5,
    bags: 3,
    ac: true,
    pricePerKm: 16,
    basePrice: 700,
    description: "Stylish compact SUV with great features and comfort. Best for intercity travel.",
    features: ["AC", "Premium Music System", "GPS", "First Aid Kit", "Panoramic Sunroof", "Wireless Charging"],
    rating: 4.6,
    reviews: 220
  },
  {
    id: "cab07",
    name: "Toyota Fortuner",
    type: "Luxury SUV",
    photo: "https://imgd.aeplcdn.com/664x374/n/cw/ec/44709/fortuner-exterior-right-front-three-quarter-19.jpeg?isig=0&q=80",
    seats: 7,
    bags: 5,
    ac: true,
    pricePerKm: 28,
    basePrice: 1500,
    description: "Premium luxury SUV for VIP travel. Ultimate comfort and powerful performance.",
    features: ["AC", "Premium Music System", "GPS", "First Aid Kit", "Leather Seats", "WiFi", "4x4", "Captain Seats"],
    rating: 4.9,
    reviews: 425
  },
  {
    id: "cab08",
    name: "Tata Nexon",
    type: "Compact SUV",
    photo: "https://imgd.aeplcdn.com/664x374/n/cw/ec/141867/nexon-exterior-right-front-three-quarter-2.jpeg?isig=0&q=80",
    seats: 5,
    bags: 2,
    ac: true,
    pricePerKm: 13,
    basePrice: 550,
    description: "Safe and reliable compact SUV with great fuel efficiency. 5-star safety rating.",
    features: ["AC", "Music System", "GPS", "First Aid Kit", "6 Airbags"],
    rating: 4.5,
    reviews: 165
  }
];

export default cabs;
